import { Box, Button } from '@mui/material';
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

function DailyReport() {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = user?.role === "coe_admin" || user?.role === "super_admin"||user?.role === "coe_report_admin";

  const getBasePath = () => {
    if (user?.role === "coe_report_viewer") {
      const formattedCoeName = user?.coeName ? user.coeName.trim().replace(/\s+/g, '-') : (user?.coe_name ? user.coe_name.trim().replace(/\s+/g, '-') : 'coe');
      return `/${formattedCoeName}/daily-report`;
    }
    if (user?.role === "coe_admin" || user?.role === "super_admin" || user?.role === "coe_report_admin") return '/admin/daily-report';
    return '/mentor/daily-report';
  };

  const basePath = getBasePath();
  const isCoeReportViewer = user?.role === "coe_report_viewer";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", alignItems: "center" }}>
      {!isCoeReportViewer && (
        <Box className="dashboard-header" sx={{ display: "flex", justifyContent: "space-evenly !important" }}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(`${basePath}/attendance`)}
            className="dashboard-header-button"
          >
            VIEW ATTENDANCE REPORT
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate(`${basePath}/practice`)}
            className="dashboard-header-button"
          >
            VIEW DAILY PRACTICE REPORT
          </Button>
        </Box>
      )}
      <Box pt={isCoeReportViewer ? 0 : 3} sx={{ width: "100%" }}>
        <Outlet />
      </Box>
    </Box>
  );
}

export default DailyReport;
